import { Component, ElementRef, Input, OnDestroy, OnInit, AfterViewInit, ViewChild, ViewEncapsulation } from '@angular/core';
//import * as Clappr from 'clappr'
declare var Clappr
declare var ClapprPip
declare var AudioTrackSelector
//declare var DashShakaPlayback
//declare var ClapprStats

import {getQualitiSelector} from './plugins/quality-selector.js'
@Component({
  selector: 'video-player-preview',
  templateUrl: './video-player-preview.component.html',
  styleUrls: [
    './video-player-preview.component.scss'
  ],
  encapsulation: ViewEncapsulation.None,
})
export class VideoPlayerPreviewComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('target', {static: true}) target: ElementRef;
 
    
  @Input() sources: {src:string, type}[]
  @Input() hasSignal: boolean = false
  @Input() src:string
  player: any //videojs.Player;
  covered: boolean  = true
 

  constructor(
    private elementRef: ElementRef,
  ) { }

  ngOnInit() {}

 
  setSource(source){
 //this.src = source
	this.covered = false;
    //this.target.nativeElement.src = source.src
    this.player.load( source)

  }

 
   
 
 ngAfterViewInit(){ 
    const QualitySelector = getQualitiSelector(Clappr)
 
  this.player = new Clappr.Player({src:this.src,
  	height: '100%',
        width: '100%',
    plugins:[ QualitySelector, ClapprPip.PipButton, ClapprPip.PipPlugin, AudioTrackSelector   ],
       events: {onReady:()=>{ 
 
  	 var video = this.target.nativeElement.querySelectorAll('video')[0];
	   if(video){
	video.setAttribute('webkit-playsinline','true');
	video.setAttribute('playsinline','true');
	 
}
  	 
	 }, }
       
  });
 
	
  this.player.attachTo(this.target.nativeElement)
       // setTimeout(()=>{
	this.setSource(this.src)  //},2000)
 // this.setSource(this.src) 

}

  ngOnDestroy() {
    if(this.player){
   	 this.player.destroy()

	}
  }
}
